import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full lg:flex lg:gap-2 lg:items-stretch" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  key: 0,
  id: "imageIdx0",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}
const _hoisted_4 = {
  id: "imageIdxEmotionalLeft",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  id: "imageIdxEmotionalRight",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  id: "imageIdx1",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}
const _hoisted_9 = {
  key: 3,
  id: "imageIdx2",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}

import ItemImage from "@/components/itemImage.vue";
import ItemV2ItemImageBrandLogo from "@/components/itemV2/itemV2ItemImageBrandLogo.vue";
import ItemV3ImageAnimationWeddingRings from "@/components/itemV3/itemV3ImageAnimationWeddingRings.vue";
import {computed, ref, watch} from "vue";
import {useI18n} from "vue-i18n";

const pageStr = "components.itemV2.itemV2ImageGrid"

/**
 image idx
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3ImageGridWeddingRings',
  props: [
  "image",
  "imageIdx",
  "popupImage",
  "itemNumber",
  "emotionalImageAnimated"
],
  emits: [
  "switchImage",
  "popupImage"
],
  setup(__props, { emit: __emit }) {

/**
 Variant 1
 image.filename exists
 image.positions[0].filename exists
 image.additionalItem.filename exists
 image.additionalItem.positions[0].filename exists

 Grid:
 row 1
 col 1: image.filename
 col 2: image.positions[0].filename
 row 2
 col 1: emotional set image left part
 col 2: emotional set image right part
 row 3
 col 1: image.additionalItem.positions[0].filename
 col 2: image.additionalItem.filename

 Variant 2
 image.filename exists
 image.positions[0].filename not exists
 image.additionalItem.filename exists
 image.additionalItem.positions[0].filename exists

 Grid:
 row 1
 col 1: image.filename
 col 2:  image.additionalItem.filename
 row 2
 col 1: emotional set image left part
 col 2: emotional set image right part
 row 3
 col 1: image.additionalItem.positions[0].filename
 col 2: placeholder - logo of the brand


 Variant 3
 image.filename exists
 image.positions[0].filename exists
 image.additionalItem.filename exists
 image.additionalItem.positions[0].filename not exists

 Grid:
 row 1
 col 1: image.filename
 col 2: image.positions[0].filename
 row 2
 col 1: emotional set image left part
 col 2: emotional set image right part
 row 3
 col 1: image.additionalItem.filename
 col 2: placeholder - logo of the brand

 Variant 4
 image.filename exists
 image.positions[0].filename not exists
 image.additionalItem.filename exists
 image.additionalItem.positions[0].filename not exists

 Grid:
 row 1
 col 1: image.filename
 col 2:  image.additionalItem.filename
 row 2
 col 1: emotional set image left part
 col 2: emotional set image right part
 row 3 is empty / does not exist

 Variant 5
 image.filename exists
 image.positions[0].filename not exists
 image.additionalItem.filename not exists
 image.additionalItem.positions[0].filename not exists

 Grid:
 Changes to one row and one col
 image.filename is placed it the middle of the only col/node but with a max width of 1500px

 Variant 6
 image.filename exists
 image.positions[0].filename exists
 image.additionalItem.filename not exists
 image.additionalItem.positions[0].filename not exists

 Grid:
 row 1
 col 1: image.filename
 col 2: image.positions[0].filename
 row 2
 col 1: emotional set image left part
 col 2: emotional set image right part
 row 3 is empty / does not exist

 */
const {t} = useI18n();
const scrollContainer = ref<HTMLElement | null>(null);
const props = __props;
const emits = __emit;

let isProgrammaticScroll = false;
let timeout: any = null;

const watchScroll = () => {
  if (isProgrammaticScroll || !scrollContainer.value) return;
  getImageInViewport();
}

watch(
    () => props.imageIdx,
    (imageIdx: string | number) => {
      isProgrammaticScroll = true;
      if (timeout) clearTimeout(timeout);

      scrollContainer.value?.querySelector("#imageIdx" + imageIdx)?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });

      // Reset the flag after the smooth scroll is likely finished
      timeout = setTimeout(() => {
        isProgrammaticScroll = false;
      }, 500);
    },
    {deep: true},
);

const getImageInViewport = () => {
  checkImageInViewport("imageIdx-1", "-1")
  checkImageInViewport("imageIdx0", "0")
  checkImageInViewport("imageIdxEmotionalLeft", "EmotionalLeft")
  checkImageInViewport("imageIdxEmotionalRight", "EmotionalRight")
  checkImageInViewport("imageIdx1", "1")
  checkImageInViewport("imageIdx2", "2")
}

const checkImageInViewport = (nodeId: string, imagePoxIdx: string) => {
  const el = scrollContainer.value?.querySelector("#" + nodeId) as HTMLElement;
  if (!el) return;

  const rect = el.getBoundingClientRect();
  const parent = scrollContainer.value; // The scroll container
  if (!parent) return;

  const parentRect = parent.getBoundingClientRect();

  // Check if the center of the element is within the viewport of the scroll container
  const elementCenter = rect.left + rect.width / 2;
  const parentCenter = parentRect.left + parentRect.width / 2;

  // If the element is mostly visible in the center (allowing some margin)
  if (Math.abs(elementCenter - parentCenter) < rect.width / 2) {
    emits('switchImage', imagePoxIdx)
  }
}

/**
 grid layout variants
 */

const hasMainPosition = computed(() => !!props.image?.positions?.[0]?.filename)
const hasAdditionalItem = computed(() => !!props.image?.additionalItem?.filename)
const hasAdditionalPosition = computed(() => !!props.image?.additionalItem?.positions?.[0]?.filename)

const layoutVariant = computed(() => {
  if (!hasAdditionalItem.value) {
    return hasMainPosition.value ? 6 : 5
  }
  if (hasMainPosition.value && hasAdditionalPosition.value) {
    return 1
  }
  if (!hasMainPosition.value && hasAdditionalPosition.value) {
    return 2
  }
  if (hasMainPosition.value && !hasAdditionalPosition.value) {
    return 3
  }
  return 4
})

const brandLogoId = computed(() => {
  return (props.itemNumber || "").toString().substring(0, 2) === "R-" ? "R" : "S"
})

/** Controls whether the emotional set image (row 2) plays its animation or shows a static image. Defaults to false. */
const emotionalImageAnimated = computed(() => props.emotionalImageAnimated === true)

/**
 emotional image
 */

const emotionalImageUrl = computed(() => {
  const rightImageUrl = props.image?.additionalItem?.filename || "-"
  if (!props.image?.filename || !rightImageUrl) return ""
  const hash_left = props.image.filename.split("/")[props.image.filename.split("/").length - 1]
  const hash_right = rightImageUrl.split("/")[rightImageUrl.split("/").length - 1]
  return "https://conf.images.rubin.jewelry/item/image/set/emo-v1/" + hash_left + "/" + hash_right
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "scrollContainer",
      ref: scrollContainer,
      class: _normalizeClass(["w-full overflow-x-auto overflow-y-hidden sticky snap-x snap-mandatory lg:snap-none no-scrollbar scroll-smooth lg:w-auto lg:min-w-0 lg:flex-1", {
          'fixed insert-0 z-50 h-screen w-screen my-auto content-center': __props.popupImage
        }]),
      onScrollPassive: watchScroll
    }, [
      (__props.popupImage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed bottom-6 right-6 z-50 w-10 h-10",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('popupImage', false))),
            "aria-label": _unref(t)(pageStr + '.close'),
            role: "button"
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              class: "size-6"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M3.22 3.22a.75.75 0 0 1 1.06 0l3.97 3.97V4.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5h2.69L3.22 4.28a.75.75 0 0 1 0-1.06Zm17.56 0a.75.75 0 0 1 0 1.06l-3.97 3.97h2.69a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0ZM3.75 15a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.69l-3.97 3.97a.75.75 0 0 1-1.06-1.06l3.97-3.97H4.5a.75.75 0 0 1-.75-.75Zm10.5 0a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l3.97 3.97a.75.75 0 0 1-1.06 1.06l-3.97-3.97v2.69a.75.75 0 0 1-1.5 0V15Z",
                "clip-rule": "evenodd"
              })
            ], -1)
          ]))], 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("ul", {
        class: _normalizeClass(["grid grid-flow-col auto-cols-max lg:grid-flow-row lg:auto-cols-auto lg:gap-2 p-0.5 bg-white relative", layoutVariant.value === 5 ? 'lg:grid-cols-1' : 'lg:grid-cols-2'])
      }, [
        _createElementVNode("li", {
          id: "imageIdx-1",
          class: _normalizeClass(["w-screen lg:w-full bg-white snap-center lg:snap-align-none", { 'lg:max-w-[1500px] lg:mx-auto': layoutVariant.value === 5 }]),
          style: {"aspect-ratio":"1/1"}
        }, [
          _createVNode(ItemImage, {
            "image-url": __props.image.filename,
            "image-layer-url": __props.image.filename_layer,
            "main-metal": __props.image.main_metal,
            "is-wedding-ring": true,
            zoom: true
          }, null, 8, ["image-url", "image-layer-url", "main-metal"])
        ], 2),
        (layoutVariant.value !== 5)
          ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
              (layoutVariant.value === 1 || layoutVariant.value === 3 || layoutVariant.value === 6)
                ? (_openBlock(), _createBlock(ItemImage, {
                    key: __props.image.positions[0].filename,
                    "image-url": __props.image.positions[0].filename,
                    "image-layer-url": __props.image.positions[0].filename_layer,
                    "main-metal": __props.image.main_metal,
                    zoom: true
                  }, null, 8, ["image-url", "image-layer-url", "main-metal"]))
                : (_openBlock(), _createBlock(ItemImage, {
                    key: 1,
                    "image-url": __props.image.additionalItem.filename,
                    "image-layer-url": __props.image.additionalItem.filename_layer,
                    "main-metal": __props.image.additionalItem.main_metal,
                    "is-wedding-ring": true,
                    zoom: true
                  }, null, 8, ["image-url", "image-layer-url", "main-metal"]))
            ]))
          : _createCommentVNode("", true),
        (layoutVariant.value !== 5)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("li", _hoisted_4, [
                (emotionalImageAnimated.value)
                  ? (_openBlock(), _createBlock(ItemV3ImageAnimationWeddingRings, {
                      key: 0,
                      "image-url": emotionalImageUrl.value,
                      "image-position": "left"
                    }, null, 8, ["image-url"]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: emotionalImageUrl.value,
                      class: "w-full h-full object-cover object-left",
                      alt: ""
                    }, null, 8, _hoisted_5))
              ]),
              _createElementVNode("li", _hoisted_6, [
                (emotionalImageAnimated.value)
                  ? (_openBlock(), _createBlock(ItemV3ImageAnimationWeddingRings, {
                      key: 0,
                      "image-url": emotionalImageUrl.value,
                      "image-position": "right"
                    }, null, 8, ["image-url"]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: emotionalImageUrl.value,
                      class: "w-full h-full object-cover object-right",
                      alt: ""
                    }, null, 8, _hoisted_7))
              ])
            ], 64))
          : _createCommentVNode("", true),
        (layoutVariant.value === 1 || layoutVariant.value === 2 || layoutVariant.value === 3)
          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
              (layoutVariant.value === 1 || layoutVariant.value === 2)
                ? (_openBlock(), _createBlock(ItemImage, {
                    key: __props.image.additionalItem.positions[0].filename,
                    "image-url": __props.image.additionalItem.positions[0].filename,
                    "image-layer-url": __props.image.additionalItem.positions[0].filename_layer,
                    "main-metal": __props.image.main_metal,
                    zoom: true
                  }, null, 8, ["image-url", "image-layer-url", "main-metal"]))
                : (_openBlock(), _createBlock(ItemImage, {
                    key: 1,
                    "image-url": __props.image.additionalItem.filename,
                    "image-layer-url": __props.image.additionalItem.filename_layer,
                    "main-metal": __props.image.additionalItem.main_metal,
                    "is-wedding-ring": true,
                    zoom: true
                  }, null, 8, ["image-url", "image-layer-url", "main-metal"]))
            ]))
          : _createCommentVNode("", true),
        (layoutVariant.value === 1 || layoutVariant.value === 2 || layoutVariant.value === 3)
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              (layoutVariant.value === 1)
                ? (_openBlock(), _createBlock(ItemImage, {
                    key: 0,
                    "image-url": __props.image.additionalItem.filename,
                    "image-layer-url": __props.image.additionalItem.filename_layer,
                    "main-metal": __props.image.additionalItem.main_metal,
                    "is-wedding-ring": true,
                    zoom: true
                  }, null, 8, ["image-url", "image-layer-url", "main-metal"]))
                : (_openBlock(), _createBlock(ItemV2ItemImageBrandLogo, {
                    key: 1,
                    "main-metal": __props.image.main_metal,
                    brand: brandLogoId.value
                  }, null, 8, ["main-metal", "brand"]))
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 34)
  ]))
}
}

})